import { PopupPanelVm } from "../../panels/popup-panel-vm";
import { Lazy } from "../lazy";
import { DebuggingPermissionsDialogGridVm } from "./debugging-permissions-dialog-grid-vm";
import { UserFunctionPermissionService } from "../../permission/user-function-permission-service";

export class DebuggingPermissionsDialogVm extends PopupPanelVm {
	public static getInstance = Lazy.singleton(DebuggingPermissionsDialogVm);

	constructor() {
		super();
		this.applyPopupOptions({
			title: ko.computed(() => `Berechtigungen (${this.grid.dataSource()?.length ?? 0})`),
			width: "80%",
			height: "80%",
			hideOnOutsideClick: (e: any) => {
				if ($(e.target).parents(".dx-popup-normal").length === 0 && $(e.target).parents(".dx-submenu").length === 0) {
					return true;
				}
				return false;
			},
		});
	}

	public grid = new DebuggingPermissionsDialogGridVm();

	public async showAsync() {
		let storage = UserFunctionPermissionService.getInstance().getPermissionStorage();
		let dataSource: any[] = typeof storage === "boolean" ? [] : (storage ?? []);

		this.grid.dataSource(dataSource);

		this.show();
	}

	protected initialize(): void { }
}